module.exports = __webpack_public_path__ + "static/media/tot_prv_cpt.722cb241.svg";